import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const UPDATE_DIARY_ENTRY_MUTATION = gql`
  mutation UpdateDiaryEntry(
    $id: ID!
    $date: ISO8601Date
    $description: String
    $tagSlug: String
    $status: DiaryStatusTypeEnum
    $weather: String
    $documentUploads: [Upload!]
  ) {
    updateDiaryEntry(
      id: $id
      date: $date
      description: $description
      tagSlug: $tagSlug
      status: $status
      weather: $weather
      documentUploads: $documentUploads
    ) {
      diaryEntry {
        id
        date
        description
        tag {
          id
          name
          slug
        }
        status
        weather
        author {
          id
          fullName
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export interface UpdateDiaryEntryInput {
  id: string;
  date?: string;
  description?: string;
  tagSlug?: string;
  status?: string;
  weather?: string;
  documentUploads?: File[];
}

export function useUpdateDiaryEntry() {
  const [mutation, { loading, error }] = useMutation(UPDATE_DIARY_ENTRY_MUTATION);

  const updateDiaryEntry = async (input: UpdateDiaryEntryInput) => {
    const { id, documentUploads, ...rest } = input;
    const variables: Record<string, unknown> = { id };
    if (rest.date != null) variables.date = rest.date;
    if (rest.description != null) variables.description = rest.description;
    if (rest.tagSlug != null) variables.tagSlug = rest.tagSlug;
    if (rest.status != null) variables.status = rest.status.toUpperCase();
    if (rest.weather != null) variables.weather = rest.weather;
    if (documentUploads?.length) variables.documentUploads = documentUploads;
    const { data } = await mutation({ variables });
    return (data as any)?.updateDiaryEntry?.diaryEntry;
  };

  return { updateDiaryEntry, loading, error };
}
